module.exports = __webpack_public_path__ + "static/fc-support-5fecd48064a05969101d39e0b4fbd196.svg";